module.exports = __webpack_public_path__ + "static/media/map_gps_arrow_territory_selected.09f5d3a2.svg";